import clone from 'lodash/cloneDeep';
import initialState from '../../store/initialState';
import {
  DEACTIVATE_ROLE_STARTING,
  DEACTIVATE_ROLE_SUCCESS,
  DEACTIVATE_ROLE_ERROR,
} from '../../constants/actionTypes';

export default function deactivateRoleReducer(state = initialState.deactivateRole, action) {
  switch (action.type) {
    case DEACTIVATE_ROLE_STARTING: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.deactivateRole.roleId);
      }

      const locationData = newState[roleId];
      locationData.saving = true;
      locationData.saved = false;
      locationData.error = null;

      return newState;
    }

    case DEACTIVATE_ROLE_SUCCESS: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.deactivateRole.roleId);
      }

      const locationData = newState[roleId];
      locationData.saving = false;
      locationData.saved = true;
      locationData.error = null;
      return newState;
    }

    case DEACTIVATE_ROLE_ERROR: {
      const {roleId} = action;
      const newState = clone(state);

      if (!newState[roleId]) {
        newState[roleId] = clone(initialState.deactivateRole.roleId);
      }

      const locationData = newState[roleId];
      locationData.saving = false;
      locationData.saved = false;
      locationData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
